var map = {
	"./7-eleven.png": 468,
	"./BPI.png": 469,
	"./GCash.png": 470,
	"./GrabPay.png": 471,
	"./PayMaya.png": 472,
	"./coins.ph.png": 473,
	"./dragonpay.png": 474,
	"./fastpay.png": 475,
	"./paycools.png": 476,
	"./paypal.png": 477,
	"./skypay.png": 478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;